var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScrollRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.01,
    height: 17,
    viewBox: "0 0 17.01 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.8 195.51) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,8.515,15.948,7.453,9.256,14.135V0h-1.5V14.135L1.072,7.453,0,8.515l7.443,7.443h0L8.505,17.01l1.062-1.052h0L17,8.515Z",
    transform: "translate(49.8 178.51) rotate(90)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScrollRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scroll-right.80925fd32c393244ccf8105d07691009.svg";